// PopupComponent.jsx
import React from "react";
import "./inputComponent.scss";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import "react-phone-number-input/style.css";

const Input = ({
    type = "text",
    label = false,
    icon = false,
    iconPosition = "left",
    id = "default",
    placeholder = "Input data here...",
    className,
    value,
    onChange,
    name,
    checked,
    disabled,
    required,
    phoneProps,
    inputProps,
}) => {
  return (
    <div className={"customFormControl " + className}>
        { label && type!=="checkbox" && type!=="radio" ? <div className="label">{label}</div> : "" }
        
        
        <div className={
            "inputWrapper " + " " +
            (type == "checkbox" ? "checkboxWrapper " : " ") +
            (type == "radio" ? "radioWrapper " : " ") +
            (icon ? "withIcon " : " ") +
            ((iconPosition == "right") ? "iconRight" : "iconLeft")
        }>
            {
                icon && (iconPosition == "left") ?
                <div className="icon">
                    {icon}
                </div> : ""
            }
            
            { (type == "phone") ? (
              <div className="phoneInputContainer">
                <PhoneInputWithCountrySelect
                  placeholder={placeholder}
                  defaultCountry="GB"
                  value={value}
                  onChange={onChange}
                  international={true}
                  withCountryCallingCode={true}
                  countryCallingCodeEditable={false}
                  countrySelectProps={{ unicodeFlags: true }}
                  disabled={disabled}
                  {...(phoneProps || {})}
                />
              </div>
            ) : "" }

            { (type == "text") ? <input type="text" placeholder={placeholder} value={value} onChange={onChange} name={name} disabled={disabled} required={required} {...(inputProps || {})} /> : "" }
            { (type == "email") ? <input type="email" placeholder={placeholder} value={value} onChange={onChange} name={name} disabled={disabled} required={required} {...(inputProps || {})} /> : "" }
            { (type == "password") ? <input type="password" placeholder={placeholder} value={value} onChange={onChange} name={name} disabled={disabled} required={required} {...(inputProps || {})} /> : "" }
            { (type == "url") ? <input type="url" placeholder={placeholder} value={value} onChange={onChange} name={name} disabled={disabled} required={required} {...(inputProps || {})} /> : "" }
            { (type == "number") ? <input type="number" placeholder={placeholder} value={value} onChange={onChange} name={name} disabled={disabled} required={required} {...(inputProps || {})} /> : "" }
            { (type == "tel") ? <input type="tel" placeholder={placeholder} value={value} onChange={onChange} name={name} disabled={disabled} required={required} {...(inputProps || {})} /> : "" }
            { (type == "textarea") ? <textarea placeholder={placeholder} value={value} onChange={onChange} name={name} disabled={disabled} required={required} {...(inputProps || {})} /> : "" }
            { (type == "file") ? <input type="file" placeholder={placeholder} onChange={onChange} name={name} disabled={disabled} required={required} {...(inputProps || {})} /> : "" }
            {
                (type == "checkbox") ?
                <>
                    <input type="checkbox" id={id} checked={checked} onChange={onChange} name={name} disabled={disabled} required={required} {...(inputProps || {})} />
                    <label htmlFor={id} className="label">{label}</label>
                </>
                : ""
            }
            {
                (type == "radio") ?
                <>
                    <input type="radio" id={id} checked={checked} onChange={onChange} name={name} disabled={disabled} required={required} value={value} {...(inputProps || {})} />
                    <label htmlFor={id} className="label">{label}</label>
                </>
                : ""
            }

            {
                icon && (iconPosition == "right") ?
                <div className="icon">
                    {icon}
                </div> : ""
            }
        </div>
    </div>
  );
};

export default Input;
